import Toast, { BaseToast, ErrorToast } from 'react-native-toast-message';
import { BottomNavigationPadding } from './FindifyNavigation';
import { PlaceTextStyle } from './PlaceText';

export const FindifyToast = ({ type, title, message, position, ...props }: any) => {
    // console.log('makeToast', { type, title, message, position });
    Toast.hide();
    setTimeout(() => {
        Toast.show({
            id: props.id,
            type: type,
            text1: title,
            text2: message,
            position: position ?? 'bottom',
            visibilityTime: props.visibilityTime ?? 4000,
            bottomOffset: BottomNavigationPadding + 20,
            ...props
        })
    }, 100);

}



export const FindifyToastConfig = {
    /*
      Overwrite 'success' type,
      by modifying the existing `BaseToast` component
    */
    success: (props: any) => (
        <BaseToast
            {...props}
            style={{
                borderLeftColor: 'green',
                backgroundColor: 'green',
            }}
            text1Style={{
                color: 'white',
                fontSize: 18,
                fontWeight: '500',
            }}
            text2Style={{
                color: 'white',
                fontSize: 14,
            }}
        />
    ),
    /*
    Overwrite 'error' type,
    by modifying the existing `ErrorToast` component
    */
    error: (props: any) => (
        <ErrorToast
            {...props}
            style={{
                borderLeftColor: 'red',
                backgroundColor: 'red',
            }}
            text1Style={{
                ...PlaceTextStyle,
                color: 'white',
                fontSize: 18,
                fontWeight: '500',
            }}
            text2Style={{
                ...PlaceTextStyle,
                color: 'white',
                fontSize: 14,
            }}
        />
    ),
    // /*
    //   Or create a completely new type - `tomatoToast`,
    //   building the layout from scratch.

    //   I can consume any custom `props` I want.
    //   They will be passed when calling the `show` method (see below)
    // */
    childToast: (props: any) => {
        return props.props.toast;
    }

};
